<template lang="pug">
    section.purchase.shipping-package(v-loading="purchase.loading")
        .head
            //- nobr.nr {{ purchase.id }}
            //- nobr.name {{ purchase.purchaser.name }}
            //- nobr.date {{ purchase.created_at | timestamp2date(dateTimeFormat) }}
            //- nobr.grand-total {{ purchase.grand_total | moneyFormat(purchase.currency) }}
            .recipient
                label.small {{ $t('Purchase \#{nr}', { nr: purchase.id }) }}, {{ $t('Shipping to') }}:
                el-dropdown(v-if="recipientOptions.length > 1" placement="bottom-start" @command="selectRecipient")
                    span.address.el-dropdown-link
                        template(v-if="recipient")
                            nobr
                                b {{ recipient.name }}
                            nobr(v-if="recipient.address") , {{ recipient.address.oneLiner }}
                            i.el-icon-arrow-down.el-icon--right
                    el-dropdown-menu(slot="dropdown")
                        el-dropdown-item(
                            v-for="(option, i) in recipientOptions" :key="option.key"
                            :divided="recipientOptions.length > 2 && i === 1"
                            :class="{ active: option.active }"
                            :command="option"
                        )
                            nobr
                                b {{ option.name }}
                            nobr(v-if="option.address") , {{ option.address.oneLiner }}
                template(v-else-if="recipient")
                    .address
                        nobr
                            b {{ recipient.name }}
                        nobr(v-if="recipient.address") , {{ recipient.address.oneLiner }}
                template(v-else)
                    .address {{ $t('Undefined') }}
            .capture
                nobr
                    el-button(
                        size="small"
                        type="success"
                        icon="el-icon-fa-box-open fas"
                        @click="openModal('pack')"
                    ) {{ $t('pack') }}
                    el-button(
                        size="small"
                        :type="shippingPackage && shippingPackage.items.length ? 'primary' : 'info'"
                        icon="el-icon-fa-dolly-flatbed fas"
                        :disabled="!shippingPackage || !shippingPackage.items.length"
                        @click="openModal('ship')"
                    ) {{ $t('ship') }}
        .items
            template(v-for="item in purchase.items")
                .stock-item(v-for="stock in item.stocks" :key="`${item.id}:${stock.id}`" :class="stock.pivot.status.key")
                    item-media-preview(:item="item")
                    .info
                        .row
                            nobr.nr {{ item.product_nr }}
                            nobr.name {{ item.name }}
                            nobr.price {{ item.sale_price || item.price | moneyFormat(purchase.currency) }}
                        .row.properties
                            property-value(
                                v-for="property in item.properties.filter(el => el.selectable === true || el.article_required === true)"
                                :key="property.id"
                                :property="property"
                            )
                        .row
                            nobr.sku
                                label {{ $t('SKU') }}:
                                span.value {{ item.sku }}
                            nobr.stock
                                label {{ $t('Stock') }}:
                                span.value {{ stock.name }}
                            nobr.qty
                                label {{ $t('Quantity') }}:
                                span.value {{ stock.pivot.qty }}
                    .actions(v-if="stock.pivot.status && stock.pivot.status.key === 'packed'")
                        .placeholder
                            //- i.el-icon-fa-dolly-flatbed.fas
                            //- svg(xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2")
                            //-     path(stroke-linecap="round" stroke-linejoin="round" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4")
                            i.el-icon-fa-clipboard-check.fas
                            //- svg(xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="22px")
                            //-     path(stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4")
                            span {{ $t('packed') }}
        el-dialog.packing-dialog(
            :title="modal.type === 'pack' ? $t('Scan the items to be shipped') : $t('Package Shipping')"
            :class="modal.type"
            :visible.sync="modal.visibility"
            :before-close="confirmDiscard(() => changedSince(modal.formSnapshot, packingState()))"
            :close-on-click-modal="false"
            top="10vh"
            width="750px"
            @closed="resetModal"
        )
            template(v-if="modal.type === 'pack'")
                el-form.modal-form(
                    ref="modalForm"
                    :model="modal.pack.form"
                    label-position="top"
                    :rules="modal.pack.rules"
                    v-loading="modal.loading"
                    @submit.prevent.native="saveModalForm"
                )
                    .modal-body
                        el-form-item.no-margin(prop="query")
                            el-autocomplete.input-with-select.is-full-width(
                                v-model="modal.pack.form.query" v-focus
                                :disabled="!filterableItems.length"
                                autocomplete="off" ref="query"
                                :fetch-suggestions="filterItems"
                                :trigger-on-focus="true"
                                @select="addSelectedItemToPackage"
                            )
                                template(slot-scope="{ item }")
                                    .item-option
                                        .row
                                            nobr.nr {{ item.product_nr }}
                                            nobr.name {{ item.name }}
                                            nobr.price {{ item.sale_price || item.price | moneyFormat(purchase.currency) }}
                                        .row.properties
                                            property-value(
                                                v-for="property in item.properties.filter(el => el.selectable === true || el.article_required === true)"
                                                :key="property.id"
                                                :property="property"
                                            )
                                        .row
                                            nobr.sku
                                                label {{ $t('SKU') }}:
                                                span.value {{ item.sku }}
                                            nobr.stock
                                                label {{ $t('Stock') }}:
                                                span.value {{ item.pivot.stock.name }}
                                            nobr.qty
                                                label {{ $t('Quantity') }}:
                                                span.value {{ item.pivot.qty }}
                                el-select(
                                    v-model="modal.pack.form.type"
                                    :disabled="!filterableItems.length"
                                    slot="prepend"
                                    placeholder=""
                                    @change="focusQueryField"
                                )
                                    el-option(:label="$t('SKU')" value="sku")
                                    el-option(:label="$t('Search')" value="search")
                                //- el-button(slot="append" icon="el-icon-fa-search fas" @click="filterItems")
                                //- template(slot="append")
                                //-     i.el-icon-fa-search.fas
                    .modal-items
                        //- .alert.warning
                        //-     p {{ $t('There are no items in this package.')}}
                        .alert.warning(v-if="modal.pack.error")
                            p {{ modal.pack.error }}
                        transition-group(name="slide-decent-vertical")
                            .modal-item(v-for="item in items" :key="item.pivot.id" :class="{ disabled: item.disabled }")
                                .info
                                    .row
                                        nobr.nr {{ item.product_nr }}
                                        nobr.name {{ item.name }}
                                        nobr.price {{ item.sale_price || item.price | moneyFormat(purchase.currency) }}
                                    .row.properties
                                        property-value(
                                            v-for="property in item.properties.filter(el => el.selectable === true || el.article_required === true)"
                                            :key="property.id"
                                            :property="property"
                                        )
                                    .row
                                        nobr.sku
                                            label {{ $t('SKU') }}:
                                            span.value {{ item.sku }}
                                        nobr.stock
                                            label {{ $t('Stock') }}:
                                            span.value {{ item.pivot.stock.name }}
                                        nobr.qty
                                            label {{ $t('Quantity') }}:
                                            span.value {{ item.pivot.qty }}
                                .actions(v-if="!item.disabled")
                                    el-button.restore-item(
                                        v-if="item.deleted"
                                        circle type="success" size="mini"
                                        icon="el-icon-fa-trash-restore fas"
                                        @click.prevent.stop="restoreShippingPackageItem(item.id)"
                                    )
                                    el-button.delete-item(
                                        v-else
                                        circle type="info" size="mini"
                                        icon="el-icon-fa-trash-alt far"
                                        @click.prevent.stop="deleteShippingPackageItem(item.id)"
                                    )
                template(slot="footer")
                    el-button(
                        size="mini"
                        icon="el-icon-fa-times fas"
                        @click="closeModal"
                    ) {{ $t('Dismiss') }}
                    transition(name="slide-decent-left")
                        el-button(
                            v-if="modal.pack.form.items.filter(el => !el.deleted).length"
                            :disabled="modal.loading"
                            size="mini"
                            type="primary"
                            icon="el-icon-fa-file-alt fas"
                            @click="() => saveModalForm('print-slip')"
                        ) {{ $t('Finalize with packing slip') }}
                    transition(name="slide-decent-left")
                        el-button(
                            v-if="modal.pack.form.items.length"
                            :disabled="modal.loading"
                            size="mini"
                            type="success"
                            icon="el-icon-fa-check fas"
                            @click="saveModalForm('save')"
                        ) {{ $t('Save and close') }}
            template(v-else-if="modal.type === 'ship'")
                el-form.modal-form(
                    ref="modalForm"
                    :model="modal.ship.form"
                    label-position="top"
                    :rules="modal.ship.rules"
                    v-loading="modal.loading"
                    @submit.prevent.native="saveModalForm"
                )
                    .modal-body
                        template(v-if="recipient")
                            dl
                                dt {{ $t('Package will be shipped to') }}
                                dd
                                    .address
                                        .company(v-if="recipient.address && recipient.address.company") {{ recipient.address.company }}
                                        .name(v-if="recipient.address && recipient.address.name") {{ recipient.address.name }}
                                        .name(v-else-if="recipient.name") {{ recipient.name }}
                                        .street(v-if="recipient.address && recipient.address.street") {{ recipient.address.street }}
                                        .city(v-if="recipient.address && (recipient.address.zipcode || recipient.address.city)")
                                            template(v-if="recipient.address.zipcode") {{ recipient.address.zipcode }}
                                            template(v-if="recipient.address.zipcode && recipient.address.city") ,&nbsp;
                                            template(v-if="recipient.address.city") {{ recipient.address.city }}

                                        .country(v-if="recipient.address.country") {{ country(recipient.address.country) }}
                                        p &nbsp;
                                        .email(v-if="purchase.purchaser.email") {{ purchase.purchaser.email }}
                                        .email(v-if="purchase.purchaser.phone") {{ purchase.purchaser.phone }}
                                        .email(v-if="purchase.purchaser.mobile") {{ purchase.purchaser.mobile }}
                            template(v-if="!needsUps")
                                el-form-item(:label="$t('Shipping Service')")
                                    el-select(v-model="modal.ship.form.shippingService")
                                        el-option(
                                            v-for="item in services"
                                            :key="item.id"
                                            :label="$t(item.name)"
                                            :value="item.id"
                                        )
                                el-form-item(v-if="modal.ship.form.shippingService != 'custom'" :label="$t('Tracking nr')")
                                    el-input(v-model="modal.ship.form.trackingNr")
                                    //- el-button.mt(
                                    //-     :disabled="modal.loading"
                                    //-     size="mini"
                                    //-     type="primary"
                                    //-     icon="el-icon-fa-check fas"
                                    //-     @click="() => saveModalForm('finalize-manual-shipping')"
                                    //- ) {{ $t('Finalize manual shipping') }}
                                el-form-item(v-else :label="$t('shipping service name')")
                                    el-input(v-model="modal.ship.form.shippingServiceName")
                                    //- el-button.mt(
                                    //-     :disabled="modal.loading"
                                    //-     size="mini"
                                    //-     type="primary"
                                    //-     icon="el-icon-fa-check fas"
                                    //-     @click="() => saveModalForm('finalize-manual-shipping')"
                                    //- ) {{ $t('Finalize manual shipping') }}
                            el-collapse(v-else v-model="activeCollapse")
                                el-collapse-item(:title="$t('Ship manually')")
                                    el-form-item(:label="$t('Shipping Service')")
                                        el-select(v-model="modal.ship.form.shippingService")
                                            el-option(
                                                v-for="item in services"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                            )
                                    el-form-item(v-if="modal.ship.form.shippingService != 'custom'" :label="$t('Tracking nr')")
                                        el-input(v-model="modal.ship.form.trackingNr")
                                        //- el-button.mt(
                                        //-     :disabled="modal.loading"
                                        //-     size="mini"
                                        //-     type="primary"
                                        //-     icon="el-icon-fa-check fas"
                                        //-     @click="() => saveModalForm('finalize-manual-shipping')"
                                        //- ) {{ $t('Finalize manual shipping') }}
                                    el-form-item(v-else :label="$t('shipping service name')")
                                        el-input(v-model="modal.ship.form.shippingServiceName")
                                        //- el-button.mt(
                                        //-     :disabled="modal.loading"
                                        //-     size="mini"
                                        //-     type="primary"
                                        //-     icon="el-icon-fa-check fas"
                                        //-     @click="() => saveModalForm('finalize-manual-shipping')"
                                        //- ) {{ $t('Finalize manual shipping') }}
                                el-collapse-item(:title="$t('Ship with UPS')" name="upsCollapse")
                                    template(v-if="!upsAccountNr")
                                        p {{ $t('No UPS account nr detected') }}
                                        p {{ $t("If you want to ship with UPS, you have to enter it under 'API keys'") }}
                                    template(v-else-if="!upsToken")
                                        p {{ $t('You are not logged in with UPS') }}
                                        p {{ $t('If you want to ship with UPS, you have to login with your UPS account.') }}
                                        p &nbsp;
                                        el-button(
                                            size="mini"
                                            type="primary"
                                            @click="loginWithUPS"
                                        ) {{ $t('login with UPS') }}
                                    template(v-else-if="!defaultStockAddress")
                                        p {{ $t('No or incomplete address for stock detected.') }}
                                        p {{ $t("If you want to ship with UPS, you have to enter it under 'Settings->Stocks'.") }}
                                    template(v-else)
                                        p.strong(v-if="upsAccountNr.type == 'account'") {{ $t('You are shipping with the UPS account nr added as API key (shopwide setting):') + upsAccountNr.nr }}
                                        p.strong(v-else-if="upsAccountNr.type == 'stock'") {{ $t('You are shipping with the UPS account nr assigned to the stock:') + upsAccountNr.nr }}
                                        el-row.nomargin(:gutter="20" v-if="!labelBase64 && !ratedShipments")
                                            el-col(:span="6")
                                            el-form.upsform(
                                                ref="formUpsWeight"
                                                :model="ups"
                                            )
                                                p {{ $t('You have to declare at least the weight of the package') }}
                                                p.mb20.red(v-if="upsError") {{ $t('missing weight') }}
                                                el-form-item.bold(:label="$t('package weight')")
                                                    el-input(v-model="ups.weight")
                                                //- p.bold {{ $t('package dimensions') }}
                                                el-form-item.bold.mb0(:label="$t('package dimensions in cm (optional)')")
                                                .flex.dimensions
                                                    el-form-item(:label="$t('length')")
                                                        el-input(v-model="ups.length")
                                                    el-form-item(:label="$t('width')")
                                                        el-input(v-model="ups.width")
                                                    el-form-item(:label="$t('height')")
                                                        el-input(v-model="ups.height")
                                                el-button(v-if="(!(modal.ship.form.trackingNr && shippingService === 'ups') && !ratedShipments && upsToken)"
                                                    size="mini"
                                                    type="primary"
                                                    @click.native="requestRatings"
                                                    :disabled="upsError"
                                                ) {{ $t('request UPS shipping options') }}
                                        template(v-if="ratedShipments")
                                            p.mb20 {{ $t('Please click on a button to create the corresponding shipment label') }}
                                            template(v-if="ups.showNegotiatedAlert")
                                                p {{ $t('No negotiated rates available - would be available, if approved by UPS.') }}
                                                p {{ $t('You see the regular rates.') }}
                                            p(v-else) {{ $t("The prices are 'negotiated rates'.") }}
                                            //- p {{ $t('The number in parantheses is the UPS code for this service.') }}
                                            table.rated-shipments(border="1" frame="void" rules="rows")
                                                tr
                                                    th.text-left {{ $t('Shipping method') }}
                                                    th.text-center {{ $t('UPS Code') }}
                                                    th.actions {{ $t('Shipping fee') }}
                                                tr(v-for="ratedShipment in ratedShipments")
                                                    td.text-left {{ upsServiceLabel(ratedShipment.Service.Code) }}
                                                    td.text-center {{ ratedShipment.Service.Code }}
                                                    td.actions
                                                        el-button.button(
                                                            size="mini"
                                                            type="primary"
                                                            @click="createUPSShipmentLabel(ratedShipment.Service.Code)"
                                                        )
                                                            span(v-if="ratedShipment.NegotiatedRateCharges") {{ ratedShipment.NegotiatedRateCharges.TotalCharge.MonetaryValue }} {{ ratedShipment.NegotiatedRateCharges.TotalCharge.CurrencyCode }}
                                                            span(v-else) {{ ratedShipment.TotalCharges.MonetaryValue }} {{ ratedShipment.TotalCharges.CurrencyCode }}
                                        p.upsSuccess(v-if="labelUrl && shippingService === 'ups'") {{ $t('UPS shipment label successfully created. Printing is in progress...') }}
                                        p.bold.mt(v-if="modal.ship.form.trackingNr") {{ $t('Tracking nr') }}
                                            p {{ modal.ship.form.trackingNr }}
                                        //- el-link.mt.blue(v-if="labelUrl && shippingService === 'ups'" :href="labelUrl" target="_blank") {{ $t('open UPS shipment label in new tab') }}
                                        el-link.mt.blue(v-if="labelUrl && shippingService === 'ups'" @click="handleClickOpenLabel") {{ $t('open UPS shipment label in new tab') }}
                        //- template(v-else)
                        template
                            iframe(v-if="upsUrl" :src="upsUrl" height="100%" frameBorder="0")

                            //- el-drawer.iframe-drawer(
                            //-     :visible.sync=""
                            //-     :wrapper-closable="false"
                            //-     :modal="true"
                            //-     size="90%"
                            //-     @closed=""
                            //- )
                            //- TODO: error
                template(slot="footer")
                    .modal-footer
                        .left
                            el-button(
                                size="mini"
                                icon="el-icon-fa-times fas"
                                @click="closeModal"
                            ) {{ $t('Close') }}
                        .right
                            //- el-button(
                            //-     :disabled="modal.loading"
                            //-     size="mini"
                            //-     type="primary"
                            //-     icon="el-icon-fa-check fas"
                            //-     @click="() => saveModalForm('finalize')"
                            //- ) {{ $t('Finalize shipping') }}
                            el-button(
                                :disabled="modal.loading"
                                size="mini"
                                type="primary"
                                icon="el-icon-fa-check fas"
                                @click="() => saveModalForm('finalize-manual-shipping')"
                            ) {{ $t('Finalize manual shipping') }}
            template(v-else)
                //- TODO
</template>

<i18n>
{
    "en": {
        "Purchase #{nr}": "Purchase #{nr}",
        "This purchase does not contain any articles with the SKU {sku}": "This purchase does not contain any articles with the SKU {sku}",
        "Purchase \\#{nr}": "Purchase \\#{nr}"
    },
    "de": {
        "Close": "Schließen",
        "SKU": "SKU",
        "Search": "Suche",
        "Quantity": "Anzahl",
        "Stock": "Lager",
        "pack": "packen",
        "ship": "versenden",
        "Purchase #{nr}": "Auftrag #{nr}",
        "Shipping to": "Versand an",
        "Package Shipping": "Paketversand",
        "Shipping Service": "Paketdienst",
        "Shipping method": "Versandart",
        "Shipping fee": "Versandkosten",
        "Tracking nr": "Sendungsnummer",
        "Package will be shipped to": "Paket wird versendet an",
        "Could not save recipient!": "Empfänger konnte nicht gespeichert werden!",
        "Could not save shipping package!": "Datensatz konnte nicht gespeichert werden!",
        "Could not print the shipping package slip!": "Paketschein konnte nicht gedruckt werden!",
        "Scan the items to be shipped": "Scanne die zu versendenden Artikel",
        "There are no items in this package.": "Es sind keine Artikel in dem Paket.",
        "Finalize with packing slip": "Abschließen mit Packliste",
        "Finalize manual shipping": "Manuellen Versand abschließen",
        "This purchase does not contain any articles with the SKU {sku}": "Diese Bestellung enthält keine Artikel mit der SKU {sku}",
        "packed": "verpackt",
        "Undefined": "Unbekannt",
        "Ship with UPS": "Per UPS versenden",
        "Ship manually": "Manuell versenden",
        "Start UPS shipment": "UPS-Versand starten",
        "login with UPS": "Mit UPS-Account einloggen",
        "create UPS shipment label": "UPS-Versandaufkleber erstellen",
        "package weight": "Paket-Gewicht (in KG)",
        "package dimensions in cm (optional)": "Paket-Maße in cm (optional)",
        "length": "Länge",
        "width": "Breite",
        "height": "Höhe",
        "shipment method": "Versand-Methode",
        "request UPS shipping options": "UPS-Versand-Optionen abrufen",
        "missing weight": "Fehlende Angabe Gewicht",
        "You have to declare at least the weight of the package": "Sie müssen mindestens das Paket-Gewicht angeben",
        "open UPS shipment label in new tab": "Versandlabel in neuem Tab öffnen",
        "UPS shipment label successfully created. Printing is in progress...": "UPS-Versandlabel erfolgreich erstellt. Der Druckvorgang wurde gestartet...",
        "No UPS account nr detected": "Es ist keine UPS-Accountnr hinterlegt.",
        "If you want to ship with UPS, you have to enter it under 'API keys'": "Falls Sie mit UPS versenden wollen, müssen Sie die Nr. im Bereich 'Api-Schlüssel' hinterlegen.",
        "You are not logged in with UPS": "Sie sind nicht mit UPS eingeloggt.",
        "If you want to ship with UPS, you have to login with your UPS account.": "Falls Sie mit UPS versenden wollen, können Sie sich mit Ihrem UPS-Account einloggen.",
        "Please click on a button to create the corresponding shipment label": "Zum Erstellen des Versandlabels bitte auf den entsprechenden Preis klicken.",
        "No negotiated rates available - would be available, if approved by UPS.": "Keine ausgehandelte (diskontierte) Tarife verfügbar - diese sind nur verfügbar, falls mit UPS vereinbart.",
        "You see the regular rates.": "Sie sehen die regulären Versandraten.",
        "The number in parantheses is the UPS code for this service.": "Die Nummer in Klammern bezeichnet den UPS Code für diese Versandoption.",
        "manual shipping completed successfully": "Manueller Versand erfolgreich abgeschlossen",
        "The prices are 'negotiated rates'.": "Die angezeigten Preise sind 'Ausgehandelte Tarife'.",
        "You are shipping with the UPS account nr added as API key (shopwide setting):": "Sie versenden mit der bei den API-Keys (shopweite Einstellung) eingetragenen UPS-Account-Nr:",
        "You are shipping with the UPS account nr assigned to the stock:": "Sie versenden mit der dem Lager zugeordneten UPS-Account-Nr:",
        "saved successfully": "Speichern erfolgreich",
        "No or incomplete address for stock detected.": "Keine bzw. unvollständige Adresse für Lager erkannt.",
        "If you want to ship with UPS, you have to enter it under 'Settings->Stocks'.": "Wenn Sie mit UPS versenden wollen, müssen Sie die Adresse unter 'Einstellungen->Lager' angeben.",
        "shipping service name": "Versandservice-Name",
        "more / user defined": "Weitere / Benutzerdefiniert",
        "No shipping": "Kein Versand"
    }
}
</i18n>

<script>
import _ from 'lodash';
import uniqid from 'uniqid';

import Fuse from 'fuse.js'
import printJS from 'print-js-updated';
import axios from 'axios';
import { useSettingsStore, useSetupStore, usePosSetupStore } from '@/stores'

import { differenceInMinutes, isPast } from 'date-fns'

import PropertyValue from '@/extensions/shop/views/Purchase/Form/Partials/PropertyValue'
import ItemMediaPreview from '@/extensions/shop/pointOfSale/views/Partials/ItemMediaPreview'

// import PointOfSaleApi from '@/extensions/shop/pointOfSale/store/api/pointOfSale';
import PurchaseApi from '@/extensions/shop/store/api/purchase';
import UPSApi from '@/extensions/shop/pointOfSale/store/api/ups'
import AuthApi from '@/store/api/system/auth';

import { country } from '@/filters'
import discardGuard from '@/mixins/discardGuard'

export default {
    name: 'ShippingPackage',
    mixins: [discardGuard],
    props: {
        purchase: {
            type: Object,
            required: true,
        },
        context: {
            type: String,
            required: true
        }
    },
    data: () => ({
        modal: {
            visibility: false,
            iframeVisibility: true,
            loading: false,
            formSnapshot: undefined,
            type: 'pack', // possible values are: [ pack / send ]
            pack: {
                error: false,
                form: {
                    query: undefined,
                    type: 'sku', // possible values are: [ sku / search ]
                    items: []
                },
                rules: {
                    // query: 'required',
                },
                filteredItems: []
            },
            ship: {
                form: {
                    shippingService: undefined,
                    trackingNr: undefined,
                },
                rules: {
                    // query: 'required',
                },
            }
        },
        labelUrl: null,
        labelBase64: null,
        upsShipmentOptions: [{
            value: '11',
            label: 'Standard'
        }, {
            value: '04',
            label: 'Express'
        }],
        upsUrl: null,
        ups: {
            weight: '',
            length: '',
            width: '',
            height: '',
            slctdShipmentOption: '11',
            trackingNr: undefined, // wofür ist das ??
            uploadId: undefined,
            showNegotiatedAlert: false,
            serviceCodes: {
                "07": "UPS Worldwide Express",
                "11": "UPS Standard",
                "54": "UPS Worldwide Express Plus",
                "65": "UPS Worldwide Saver",
                "74": "UPS Express 12:00"
            }
        },
        upsrules: {
            weight: 'required'
        },
        ratedShipments: null,
        activeCollapse: [],
        services: [
            { id: 'dhl', name: 'DHL' },
            { id: 'gls', name: 'GLS' },
            { id: 'hermes', name: 'Hermes' },
            { id: 'ups', name: 'UPS' },
            { id: 'click-and-collect', name: 'Click & Collect' },
            { id: 'custom', name: 'more / user defined' },
            { id: 'none', name: 'No shipping' }
        ]
    }),
    components: {
        PropertyValue,
        ItemMediaPreview,
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore();
        },
        // upsUrl() {
        //     const redirectUri = process.env.VUE_APP_UPS_REDIRECT_URI;
        //     const clientId = process.env.VUE_APP_UPS_CLIENT_ID;
        //     const upsInitUrl = process.env.VUE_APP_API_ENDPOINT + "ups/validateclient?redirect_uri=" + redirectUri;
        //     return this.data.LassoRedirectURL + "?client_id=" + clientId + "&redirect_uri=" + redirectUri + "&response_type=code&scope=read&type=" + data.type;
        // },
        defaultStockAddress() {
            let address;
            // const defaultStock = this.activePointOfSale.stocks.find(item => item.key == "default")
            const stocks = this.activePointOfSale.stocks || []
            if (stocks.length === 0) return null

            const defaultStock = stocks[0]

            if (defaultStock && defaultStock.address) {
                if (defaultStock.address.company != "" && defaultStock.address.street != "" && defaultStock.address.zipcode != "" && defaultStock.address.country != "") {
                    address = defaultStock.address;
                }
            }
            return address;
        },
        needsUps() {
            return !!this.requirements.find(requirement => {
                return requirement.key === 'ups-account-nr' && requirement.context === 'shop'
            })
        },
        requirements() {
            return _.get(this.template, 'requirements') || []
        },
        template: {
            get() {
                return _.get(this.form, 'config.template')
            },
            set(value) {
                useSettingsStore().setFormTemplate(value)
            }
        },
        sendToStock() {
            let sendToStock = false

            // let features = _.get(this.activeCms, 'config.template.features') || [];
            // const feature = features.find(el => el.startsWith('ship-package-to-default-stock-if-recipient-is-not-in-these-countries'));
            // if (feature && this.options.stock.items.find(el => el.key === 'default')) {
            //     const { groups: { countries } } = /\[(?<countries>.*)\]/g.exec(feature)
            //     const codes = countries.split(',')
            //     const code = _.get(this.purchase, 'purchaser.shippingAddress.country')
            //
            //     if (!code || !codes.includes(code)) sendToStock = true
            // }

            const memberTags = _.get(this.purchase, 'purchaser.customer.member.memberTags') || []
            if (this.activePointOfSale.use_stock_address_for_members && this.activePointOfSale.stock && memberTags.length) {
                const stockAddressMemberTagIDs = (this.activePointOfSale.stockAddressMemberTags || []).map(el => el.id)
                memberTags.forEach(tag => {
                    if (stockAddressMemberTagIDs.includes(tag.id)) {
                        sendToStock = this.activePointOfSale.stock
                    }
                })
            }

            return sendToStock
        },
        recipientOptions() {

            let active = true
            if (_.get(this.shippingPackage, 'stock')) active = false
            else if (!this.shippingPackage && this.sendToStock) active = false

            let options = [{
                key: 'purchaser',
                type: 'purchaser',
                active,
                name: this.purchase.purchaser.name,
                address: this.purchase.purchaser.shippingAddress,
            }]

            const stocks = this.activePointOfSale.stocks || []

            // let ownStockIDs = this.activePointOfSale.stocks.map(el => el.id)
            let ownStockIDs = []

            if (this.context == 'POS') {
                ownStockIDs = stocks.map(el => el.id)
            } else if (this.context == 'SALES') {
                ownStockIDs.push(this.activeStock.id)
            }

            this.options.stock.items.forEach(stock => {
                if (ownStockIDs.includes(stock.id)) return

                let active = false
                if (_.get(this.shippingPackage, 'stock.id') === stock.id) active = true
                else if (!this.shippingPackage && this.sendToStock && stock.id === this.sendToStock.id) active = true

                options.push({
                    key: `stock-${stock.key}`,
                    id: stock.id,
                    type: 'stock',
                    active,
                    name: stock.name,
                    address: stock.address,
                })
            })

            return options
        },
        recipient() {
            return this.recipientOptions.find(el => el.active)
        },
        shippingPackage() {
            let returnEl;

            // if (this.activePointOfSale.id) {
            if (this.context == 'POS') {
                returnEl = this.purchase.shippingPackages.find(el => {
                    return el.pointOfSale.id === this.activePointOfSale.id && el.status.key === 'packing'
                })
            }
            // if (this.activeStock.id) {
            else if (this.context == 'SALES') {
                returnEl = this.purchase.shippingPackages.find(el => {
                    return el.items[0].pivot.stock.id === this.activeStock.id && el.status.key === 'packing'
                })
            }

            return returnEl
        },
        filterableItems() {
            let items = []
            this.purchase.items.forEach(item => {
                item.stocks.forEach(stock => {
                    // check if duplicate by pivot id instead of item id
                    if (this.shippingPackage && this.shippingPackage.items.findIndex(el => el.id == item.id && el.pivot.stock.id == stock.id) >= 0) return
                    if (this.modal.pack.form.items.findIndex(el => el.id == item.id && el.pivot.stock.id == stock.id) >= 0) return

                    let option = _.cloneDeep(item)
                    delete option.stocks

                    stock = _.cloneDeep(stock)
                    option.pivot = {
                        // id: stock.pivot.id,
                        id: uniqid('new:'),
                        qty: stock.pivot.qty,
                        // pointOfSale: stock.pivot.pointOfSale,
                        // status: stock.pivot.status,
                        stock: stock,
                    }
                    delete option.pivot.stock.pivot

                    items.push(option)
                })
            })
            return items
        },
        items() {
            // return this.modal.pack.form.items.slice().reverse()

            let filterableItems = _.cloneDeep(this.filterableItems)
            filterableItems.forEach(item => item.disabled = true)

            const packedItems = _.get(this.modal, 'pack.form.items') || []
            return [...packedItems, ...filterableItems]
                .sort((a, b) => parseInt(a.id) - parseInt(b.id))
        },
        upsToken() {
            return localStorage.getItem("upstoken")
        },
        shippingService() {
            return this.modal.ship.form.shippingService
        },
        upsAccountNr() {
            var el;
            //Shop-weite UPS-Account-Nr (API-Key), wird im folgenden überschrieben, falls im Lager vorhanden
            if (this.form.apiKeys) {
                el = _.find(this.form.apiKeys, apiKey => apiKey.key === 'ups-account-nr');
                if (el) {
                    el = {
                        nr: el.public,
                        type: "account"
                    }
                }
            }

            //dem Standard-Lager des aktiven POS zugeordnete UPS-Account-Nr
            if (this.context == 'POS') {
                if (this.activePointOfSale.id && this.activePointOfSale.stock && this.activePointOfSale.stock.length) {
                    // var defaultStock = this.activePointOfSale.stocks.find(item => item.key == "default")
                    var defaultStock = this.activePointOfSale.stocks[0]
                    if (defaultStock) {
                        if (defaultStock.metas.length && defaultStock.metas.find(item => item.key == "ups-account-nr").value) {
                            el = {
                                nr: this.activePointOfSale.stocks[0].metas.find(item => item.key == "ups-account-nr").value,
                                type: "stock"
                            }
                        }
                    }
                }
            }
            //dem aktiven Lager zugeordnete UPS-Account-Nr
            else if (this.context == 'SALES' && this.activeStock.id && this.activeStock.metas.length) {
                if (el = this.activeStock.metas.find(item => item.key == "ups-account-nr")) {
                    el = {
                        nr: el.value,
                        type: "stock"
                    }
                }
            }

            return el;
        },
        upsError() {
            if (this.ups.weight !== '' || (this.ups.length !== '' && this.ups.width !== '' && this.ups.height !== '')) {
                return false
            }
            else return true
        },
        form() {
            return useSettingsStore().form
        },
        activeCms() {
            return useSetupStore().activeCms
        },
        uploadEndpoint() {
            return useSetupStore().uploadEndpoint
        },
        options() {
            return this.posSetupStore.options;
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        activeStock() {
            return this.posSetupStore.activeStock;
        },
    },
    methods: {
        handleClickOpenLabel() {
            // var string = document.output(this.labelUrl);
            var iframe = "<iframe width='100%' height='100%' src='" + this.labelUrl + "'></iframe>"
            var x = window.open();
            x.document.open();
            x.document.write(iframe);
            x.document.close();
        },
        upsRefreshNeeded() {
            let upsToken = JSON.parse(localStorage.getItem("upstoken"))

            if (upsToken && upsToken.expires_in) {
                let expTime = parseInt(upsToken.issued_at) + parseInt((upsToken.expires_in * 1000));
                const expirationDate = new Date(expTime)
                const minutesLeft = differenceInMinutes(expirationDate, new Date)
                const expired = isPast(expirationDate)
                if (minutesLeft < 60 || expired) return true
            }
            return false
        },
        country(i) {
            const language = 'de'
            return country(i, language)
        },
        upsServiceLabel(code) {
            return this.ups.serviceCodes[code] || ""
        },
        focusQueryField() {
            this.$nextTick(() => {
                // console.log(this.$refs.query)
                this.$refs.query.focus()
            })
        },
        clearQueryField() {
            this.modal.pack.form.query = undefined
        },
        changeRecipient(value) {
            let shippingPackage = _.cloneDeep(this.shippingPackage)
            if (!shippingPackage) {
                shippingPackage = {
                    purchase: { id: this.purchase.id },
                    pointOfSale: { id: this.activePointOfSale.id },
                };
            }

            if (value.type === 'stock') {
                shippingPackage.stock = { id: value.id }
            } else if (shippingPackage.stock) {
                shippingPackage.stock.deleted = true
            }

            return shippingPackage
        },
        selectRecipient(value) {
            const shippingPackage = this.changeRecipient(value)

            let save = this.createShippingPackage
            if (shippingPackage.id) save = this.updateShippingPackage

            save(shippingPackage)
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Could not save recipient!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                    console.error(err)
                })
        },
        openModal(type = 'pack') {
            this.modal.type = type
            this.modal.visibility = true
            this.updateAutofocusSearchInput(false)
            switch (type) {
                case 'pack':
                    if (this.shippingPackage && this.shippingPackage.items) {
                        this.modal.pack.form.items = _.cloneDeep(this.shippingPackage.items)
                    }
                    this.$nextTick(() => {
                        this.$refs.query.focus()
                    })
                    break;

                case 'ship':
                    // TODO
                    break;

                default:
                    this.modal.visibility = false
                    this.updateAutofocusSearchInput(true)
                    break;
            }
            this.modal.formSnapshot = this.snapshotOf(this.packingState())
        },
        // what the dialog accumulates before "Save": the scanned items and the shipping details
        packingState() {
            return { items: this.modal.pack.form.items, ship: this.modal.ship.form }
        },
        closeModal() {
            this.modal.visibility = false
            this.updateAutofocusSearchInput(true)
        },
        resetModal() {
            this.modal = {
                visibility: false,
                loading: false,
                type: 'pack', // possible values are: [ pack / send ]
                pack: {
                    error: false,
                    form: {
                        query: undefined,
                        type: 'sku', // possible values are: [ sku / search ]
                        items: []
                    },
                    rules: {
                        // query: 'required',
                    },
                    filteredItems: []
                },
                ship: {
                    form: {
                        shippingService: undefined,
                        trackingNr: undefined,
                    },
                    rules: {
                        // query: 'required',
                    },
                }
            }
            this.ups = {
                weight: '',
                length: '',
                width: '',
                height: '',
                slctdShipmentOption: '11',
                trackingNr: undefined,
                uploadId: undefined,
                showNegotiatedAlert: false,
            },
                this.updateAutofocusSearchInput(true)
        },
        filterItems(query, callback) {
            const abort = () => {
                callback([])
                return false
            }

            this.modal.pack.error = false
            if (!this.filterableItems.length || !query) return abort();

            if (this.modal.pack.form.type === 'sku') {
                // filter by SKU
                this.modal.pack.filteredItems = this.filterableItems.filter(el => el.sku === query)

                if (this.modal.pack.filteredItems.length === 1) {
                    this.addFoundItemToPackage()
                    return abort();
                } else if (this.modal.pack.filteredItems.length > 1) {
                    this.modal.pack.filteredItems
                    callback(this.modal.pack.filteredItems)
                } else {
                    // not found
                    this.modal.pack.error = this.$t('This purchase does not contain any articles with the SKU {sku}', { sku: query })
                    return abort();
                }
            } else {
                // filter by name, etc.
                const settings = {
                    shouldSort: true,
                    tokenize: true,
                    matchAllTokens: true,
                    threshold: 0.3,
                    minMatchCharLength: 1,
                    keys: ['name', 'price', 'product_nr', 'sku', 'properties.value.text', 'properties.value.number'],
                }
                const fuse = new Fuse(this.filterableItems, settings)
                const result = _.map(fuse.search(query), el => el.item)
                this.modal.pack.filteredItems = result
                callback(this.modal.pack.filteredItems)
            }
        },
        addSelectedItemToPackage(item) {
            // check if duplicate by pivot id before pushing to array
            if (this.modal.pack.form.items.findIndex(el => el.pivot.id === item.pivot.id) < 0) {
                this.modal.pack.form.items.push(item)
                this.modal.pack.filteredItems = []
                this.modal.pack.form.query = undefined
            }

            this.$nextTick(() => {
                if (this.filterableItems.length > 0) this.focusQueryField()
                else this.clearQueryField()
            })
        },
        addFoundItemToPackage() {
            // check if there is only one item in filtered list
            // and add it to the shipping package

            // check if duplicate by pivot id before pushing to array
            if (this.modal.pack.filteredItems.length === 1
                && this.modal.pack.form.items.findIndex(el => el.pivot.id === this.modal.pack.filteredItems[0].pivot.id) < 0
            ) {
                this.modal.pack.form.items.push(this.modal.pack.filteredItems[0])
                this.modal.pack.filteredItems = []
                this.modal.pack.form.query = undefined
            }

            this.$nextTick(() => {
                if (this.filterableItems.length > 0) this.focusQueryField()
                else this.clearQueryField()
            })
        },
        deleteShippingPackageItem(id) {
            const i = this.modal.pack.form.items.findIndex(item => item.id === id)
            if (i >= 0) this.$set(this.modal.pack.form.items[i], 'deleted', true)
        },
        restoreShippingPackageItem(id) {
            const i = this.modal.pack.form.items.findIndex(item => item.id === id && item.deleted)
            if (i >= 0) this.$delete(this.modal.pack.form.items[i], 'deleted')
        },
        saveModalForm(action = 'save') {
            if (this.modal.type === 'pack' && !this.modal.pack.form.items.length) return false

            this.modal.loading = true

            let shippingPackage = _.cloneDeep(this.shippingPackage)
            if (!shippingPackage) {
                shippingPackage = {
                    purchase: { id: this.purchase.id },
                    pointOfSale: { id: this.activePointOfSale.id },
                };

                if (this.sendToStock) {
                    // const stock = this.options.stock.items.find(el => el.key === 'default');
                    // shippingPackage.stock = { id: stock.id }
                    shippingPackage.stock = { id: this.sendToStock.id }
                }
            }

            if (this.modal.type === 'pack') {
                shippingPackage.items = this.modal.pack.form.items
            } else if (this.modal.type === 'ship') {
                shippingPackage.shipping_service = this.modal.ship.form.shippingService
                shippingPackage.tracking_nr = this.modal.ship.form.trackingNr

                if (shippingPackage.shippingService == 'custom') {
                    shippingPackage.shippingServiceName = this.modal.ship.form.shippingServiceName
                }

                shippingPackage.status = { key: 'shipped' }
                if (shippingPackage.stock) shippingPackage.status.key = 're-ordered';
            }

            let save = this.createShippingPackage
            if (shippingPackage.id) save = this.updateShippingPackage

            //set shipmentLabel, if shipping with ups
            if (this.ups.uploadId !== undefined) {
                shippingPackage.shipmentLabel = { id: this.ups.uploadId }
            }

            save(shippingPackage)
                .then(data => {
                    if (action === 'print-slip') {
                        // print packing list
                        const printable = PurchaseApi.shippingPackageSlipRenderingUrl(data.id)
                        printJS({
                            printable,
                            onLoadingEnd: () => {
                                // Don't close modal here - wait for print dialog
                            },
                            onError: () => {
                                this.modal.loading = false
                                this.$notify.error({
                                    title: this.$t('An error occurred!'),
                                    message: this.$t('Could not print the shipping package slip!'),
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000,
                                })
                            },
                            onPrintDialogClose: () => {
                                this.modal.loading = false
                                this.closeModal()
                            }
                        })
                    } else if (action === 'finalize-ups-shipping') {
                        // if (this.ups.uploadId !== undefined) {
                        if (this.labelBase64 !== undefined && this.labelBase64 != null && this.labelBase64 !== "") {
                            let printableS = "data:image/gif;base64," + this.labelBase64

                            printJS({
                                printable: printableS,
                                type: 'image',
                                base64: true,
                                onPrintDialogClose: () => {
                                    this.modal.loading = false
                                }
                            });

                            // printJS({
                            //     printable, onLoadingEnd: () => {
                            //         this.modal.loading = false
                            //         this.closeModal()
                            //     }, onError: () => {
                            //         this.modal.loading = false
                            //         this.$notify.error({
                            //             title: this.$t('An error occurred!'),
                            //             message: this.$t('Could not print the shipping package slip!'),
                            //             iconClass: 'fas el-icon-fa-times',
                            //             position: 'bottom-left',
                            //             customClass: 'dark',
                            //             duration: 8000,
                            //         })
                            //     }
                            // })
                        }

                    }
                    else if (action === 'finalize-manual-shipping') {
                        this.$notify.success({
                            title: this.$t('manual shipping completed successfully'),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                        this.closeModal()
                    }
                    else if (action === 'save') {
                        this.modal.loading = false
                        this.$notify.success({
                            title: this.$t('saved successfully'),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                        this.closeModal()
                    }
                })
                .catch(err => {
                    this.modal.loading = false
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Could not save shipping package!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                    console.error(err)
                })
        },
        async loginWithUPS() {
            const redirectUri = process.env.VUE_APP_UPS_REDIRECT_URI;
            const clientId = process.env.VUE_APP_UPS_CLIENT_ID;
            const upsInitUrl = process.env.VUE_APP_API_ENDPOINT + 'ups/validateclient?redirect_uri=' + redirectUri;

            var upsLoginStatus = { url: this.$route.path, packageId: this.shippingPackage.id }
            localStorage.setItem('upsLoginStatus', JSON.stringify(upsLoginStatus));

            axios.get(upsInitUrl)
                .then(({ data }) => {

                    const query = new URLSearchParams({
                        client_id: clientId,
                        redirect_uri: redirectUri,
                        response_type: 'code',
                        scope: 'myscope',
                        state: 'mystate',
                        type: data.type
                    }).toString();

                    // this.upsUrl = data.LassoRedirectURL + "?client_id=" + clientId + "&redirect_uri=" + redirectUri + "&response_type=code&scope=read&type=" + data.type;
                    // window.location = data.LassoRedirectURL + "?client_id=" + clientId + "&redirect_uri=" + redirectUri + "&response_type=code&scope=read&type=" + data.type;
                    window.location = data.LassoRedirectURL + "?" + query;
                    // window.open(data.LassoRedirectURL + "?client_id=" + clientId + "&redirect_uri=" + redirectUri + "&response_type=code&scope=read&type=" + data.type, "_blank");
                })
                .catch(error => {
                    console.error(error)
                    this.rendering.receipt = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Receipt could not be rendered'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        },
        requestRatings() {

            this.modal.loading = true

            // const address = this.purchase.shippingPackages[0].items[0].pivot.stock.address;
            //TODO Adresse kommt aktuell aus Default-Stock, in Zukunft evtl. Lager-Auswahl machen
            const address = this.defaultStockAddress;

            const upsAccountNr = this.upsAccountNr.nr;

            const body = {
                upsAccessToken: JSON.parse(localStorage.getItem("upstoken")).access_token,
                upsRequest: {
                    RateRequest: {
                        Request: {
                            TransactionReference: {
                                CustomerContext: 'CustomerContext',
                                TransactionIdentifier: 'TransactionIdentifier'
                            }
                        },
                        Shipment: {
                            Description: '', // can be left empty
                            Shipper: {
                                Name: address.company,
                                AttentionName: address.company,
                                Phone: {
                                    Number: address.phone
                                },
                                ShipperNumber: upsAccountNr, //six digits, e.g. AB1111
                                Address: {
                                    AddressLine: address.street,
                                    City: address.city,
                                    PostalCode: address.zipcode,
                                    CountryCode: address.country
                                }
                            },
                            ShipTo: {
                                Name: this.recipient.name,
                                Address: {
                                    AddressLine: this.recipient.address.street,
                                    City: this.recipient.address.city,
                                    PostalCode: this.recipient.address.zipcode,
                                    CountryCode: this.recipient.address.country
                                }
                            },
                            ShipFrom: {
                                Name: address.company,
                                AttentionName: address.company,
                                Phone: { Number: address.phone },
                                Address: {
                                    AddressLine: address.street,
                                    City: address.city,
                                    PostalCode: address.zipcode,
                                    CountryCode: address.country
                                }
                            },
                            PaymentDetails: {
                                //01 (transportation) is standard, not sure if 02 (duties) and 03 (Broker of Choice) would be applied in some cases
                                //https://developer.ups.com/api/reference?loc=de_DE#operation/Shipment
                                ShipmentCharge: {
                                    Type: '01',
                                    BillShipper: { AccountNumber: upsAccountNr }
                                }
                            },
                            //required for Negotiated Rates
                            //always set yes, because "normal" rates are delivered anyway
                            ShipmentRatingOptions: {
                                NegotiatedRatesIndicator: 'Y'
                            },
                            NumOfPieces: 1,
                            Package: {
                                PackagingType: {
                                    Code: '02', //02 is custom packaging, other packaging types could be needed in the future
                                    Description: '' // can be left empty
                                },
                                PackageWeight: {
                                    UnitOfMeasurement: {
                                        Code: 'KGS',
                                        Description: 'kilogram'
                                    },
                                    Weight: this.ups.weight
                                }
                            }
                        },
                        LabelSpecification: {
                            HTTPUserAgent: 'Mozilla/4.5',
                            LabelImageFormat: { Code: 'GIF' }
                        }
                    }
                }
            };

            if (this.ups.length !== "" && this.ups.width !== "" && this.ups.height !== "") {
                body.upsRequest.RateRequest.Shipment.Package.Dimensions = {
                    UnitOfMeasurement: {
                        Code: 'CM',
                        Description: 'Centimeters'
                    },
                    Length: this.ups.length,
                    Width: this.ups.width,
                    Height: this.ups.height
                }
            }
            if (this.upsRefreshNeeded()) {
                UPSApi.refreshToken().then((data) => {
                    body.upsAccessToken = JSON.parse(localStorage.getItem("upstoken")).access_token
                    this.requestUPSRatings(body);
                }).catch((err) => console.log(err)).finally(() => this.modal.loading = false)
            }
            else {
                this.requestUPSRatings(body);
            }
        },
        requestUPSRatings(body) {
            UPSApi.requestRatings(body).then((data) => {

                if (data.response && data.response.errors) {
                    var errorString = ""
                    for (var error of data.response.errors) {
                        errorString += error.code + " " + error.message + " "
                    }

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: errorString,
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: -1,
                    })
                    this.modal.loading = false
                }
                else {
                    if (data.RateResponse) {
                        this.ratedShipments = data.RateResponse.RatedShipment;
                        if (this.ratedShipments[0].RatedShipmentAlert[0] && this.ratedShipments[0].RatedShipmentAlert[0].Code == 120900) {
                            this.ups.showNegotiatedAlert = true
                        }
                        else {
                            this.ups.showNegotiatedAlert = false
                        }
                    }
                }
            }).catch((err) => console.log(err)).finally(() => this.modal.loading = false)
        },
        createUPSShipmentLabel(serviceCode) {
            this.ratedShipments = null
            this.modal.loading = true

            let address;
            if (this.context == 'POS' && this.activePointOfSale.stocks && this.activePointOfSale.stocks.length) {
                // TODO bei mehreren zugehörigen Stocks Adressen auswählbar machen
                address = this.activePointOfSale.stocks[0].address;
            } else if (this.context == 'SALES') {
                address = this.activeStock.address;
            }

            const upsAccountNr = this.upsAccountNr.nr;
            var phoneTo = "";
            if (this.recipient.phone != "") phoneTo = this.recipient.phone
            if (this.recipient.mobile != "") phoneTo = this.recipient.mobile
            const body = {
                upsAccessToken: JSON.parse(localStorage.getItem("upstoken")).access_token,
                upsRequest: {
                    ShipmentRequest: {
                        Request: {
                            SubVersion: '1801',
                            RequestOption: 'nonvalidate',
                            TransactionReference: { CustomerContext: '' }
                        },
                        Shipment: {
                            Description: '', // can be left empty
                            Shipper: {
                                Name: address.company,
                                AttentionName: address.company,
                                Phone: {
                                    Number: address.phone
                                },
                                ShipperNumber: upsAccountNr, //six digits, e.g. AB1111
                                Address: {
                                    AddressLine: address.street,
                                    City: address.city,
                                    PostalCode: address.zipcode,
                                    CountryCode: address.country
                                }
                            },
                            ShipTo: {
                                Name: this.recipient.name,
                                AttentionName: this.recipient.name,
                                Address: {
                                    AddressLine: this.recipient.address.street,
                                    City: this.recipient.address.city,
                                    PostalCode: this.recipient.address.zipcode,
                                    CountryCode: this.recipient.address.country
                                }
                            },
                            ShipFrom: {
                                Name: address.company,
                                AttentionName: address.company,
                                Phone: { Number: address.phone },
                                Address: {
                                    AddressLine: address.street,
                                    City: address.city,
                                    PostalCode: address.zipcode,
                                    CountryCode: address.country
                                }
                            },
                            PaymentInformation: {
                                ShipmentCharge: {
                                    //01 (transportation) is standard, not sure if 02 (duties) and 03 (Broker of Choice) would be applied in some cases
                                    //https://developer.ups.com/api/reference?loc=de_DE#operation/Shipment
                                    Type: '01',
                                    BillShipper: { AccountNumber: upsAccountNr }
                                }
                            },
                            Service: {
                                Code: serviceCode
                            },
                            Package: {
                                Packaging: {
                                    Code: '02', //02 is custom packaging, other packaging types could be needed in the future
                                    Description: '' //can be left empty
                                },
                                PackageWeight: {
                                    UnitOfMeasurement: {
                                        Code: 'KGS',
                                        Description: 'kilogram'
                                    },
                                    Weight: this.ups.weight
                                }
                            }
                        },
                        LabelSpecification: {
                            HTTPUserAgent: 'Mozilla/4.5',
                            LabelImageFormat: { Code: 'GIF' }
                        },
                    }
                }
            };

            if (phoneTo != "") {
                var addPhone = {
                    Number: phoneTo
                }
                body.upsRequest.ShipmentRequest.Shipment.ShipTo.Phone = addPhone
            }

            if (this.ups.length !== "" && this.ups.width !== "" && this.ups.height !== "") {
                body.upsRequest.ShipmentRequest.Shipment.Package.Dimensions = {
                    UnitOfMeasurement: {
                        Code: 'CM',
                        Description: 'Centimeters'
                    },
                    Length: this.ups.length,
                    Width: this.ups.width,
                    Height: this.ups.height
                }
            }
            if (this.upsRefreshNeeded()) {
                UPSApi.refreshToken().then((data) => {
                    body.upsAccessToken = JSON.parse(localStorage.getItem("upstoken")).access_token
                    this.createShipment(body);
                }).catch((err) => console.log(err)).finally(() => this.modal.loading = false)
            }
            else {
                this.createShipment(body);
            }

        },
        createShipment(body) {
            UPSApi.createShipment(body).then((data) => {
                if (data.response && data.response.errors) {
                    var errorString = ""
                    for (var error of data.response.errors) {
                        errorString += error.code + " " + error.message + " "
                    }

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: errorString,
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: -1,
                    })
                    this.modal.loading = false
                    //#
                }
                else if (data.ShipmentResponse) {
                    this.labelUrl = "data:image/gif;base64," + data.ShipmentResponse.ShipmentResults.PackageResults.ShippingLabel.GraphicImage;
                    this.labelBase64 = data.ShipmentResponse.ShipmentResults.PackageResults.ShippingLabel.GraphicImage;
                    this.modal.ship.form.trackingNr = data.ShipmentResponse.ShipmentResults.ShipmentIdentificationNumber;
                    this.modal.ship.form.shippingService = 'ups';
                    this.uploadShipmentLabel();
                    // this.shippingType = 'UPS'
                }

            }).catch((err) => console.error(err))
        },
        uploadShipmentLabel() {
            this.modal.loading = true

            const token = AuthApi.getToken();

            const fd = new FormData();
            fd.append("context[type]", "original");

            let buffer = this.b64toBlob(this.labelBase64);
            fd.append("file", buffer, "shipment-label.gif");
            axios.post(this.uploadEndpoint + '/private/' + this.activeCms.id + '/shop', fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    authorization: `Bearer ${token}`
                }
            })
                .then((response) => this.uploadSucceed(response.data))
                .finally(() => this.modal.loading = false)
        },
        b64toBlob(b64Data, contentType = 'image/gif', sliceSize = 512) {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: contentType });
            return blob;
        },
        uploadSucceed(response) {
            this.ups.uploadId = response.id
            this.saveModalForm('finalize-ups-shipping')
        },
        updateAutofocusSearchInput(value) {
            this.posSetupStore.updateAutofocusSearchInput(value);
        },
        createShippingPackage(shippingPackage) {
            return this.posSetupStore.createShippingPackage(shippingPackage);
        },
        updateShippingPackage(shippingPackage) {
            return this.posSetupStore.updateShippingPackage(shippingPackage);
        },
    },
    mounted() {
        let upsLoginStatus = JSON.parse(localStorage.getItem("upsLoginStatus"));
        if (upsLoginStatus) {
            if (this.shippingPackage && upsLoginStatus.packageId === this.shippingPackage.id) {
                this.openModal('ship');
                this.activeCollapse.push('upsCollapse')
                localStorage.removeItem("upsLoginStatus")
            }
        }
    }
}
</script>

<style lang="sass" scoped>

.pending-purchases
    flex-direction: column
    .recipient .el-dropdown
        display: block
    .el-dropdown-link
        cursor: pointer
        color: $--shop-color-primary
    & > .el-loading-mask
        position: fixed
        // width: calc(50% - 56px)
        // left: calc(50% + 56px)
        // top: 123px
        // height: 100%
        width: 50%
        left: 50%
        top: 62px
        bottom: 0

    .purchase
        & + .purchase
            margin-top: 2rem
            // &:before
            //     content: ''
            //     display: block;
            //     width: 100%;
            //     margin-bottom: 2rem;
            //     height: 12px;
            //     background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='20' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25 1c-5 0-5 10-10 10S10 1 5 1 0 11-5 11-10 1-15 1' stroke='%23CBD5DF' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='square'/%3E%3C/svg%3E");

        .head
            height: 48px
            // padding: 6px 12px
            padding: 6px 0
            // background: rgba(140, 147, 157, 0.2)
            // border-radius: 1rem
            margin-bottom: 0.5rem
            // display: flex
            // justify-content: space-between
            display: grid
            grid-template-columns: auto min-content
            gap: 1rem
            .grand-total
                text-align: right
                min-width: 80px
            .capture
                display: flex
                align-items: center

    .stock-item, .modal-item
        padding-right: 12px
        display: flex
        label
            font-weight: bold
        .info
            flex-grow: 1
            min-width: 0
            padding: 6px 0
        .actions
            display: flex
            gap: 0.25rem
            flex-direction: column
            justify-content: space-around
            // flex-basis: 100px
            min-width: 120px
            // margin-right: -6px
            .el-button
                margin-left: 0
            &.done
                justify-content: space-between
                .el-button
                    flex-grow: 1
                    border-radius: 0.8rem
        .row
            display: flex
            gap: 0.5rem
            & + .row
                margin-top: 0.25rem
        .name
            flex-grow: 1
            min-width: 0
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
        .sku
            flex-grow: 1

    label + span.value:before
        content: ' '

    label
        font-style: italic
        &.small
            font-size: 0.8em

    .stock-item
        gap: 12px
        padding: 6px 12px
        padding-left: 6px
        // background: rgb(220, 221, 223, 0.5)
        background: rgba(255,255,255, 0.4)
        // border-radius: 1rem
        border-radius: 4px
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.04), 0 3px 1px -2px rgba(0,0,0,0.02), 0 1px 5px 0 rgba(0,0,0,0.1)
        &.packed
            padding-right: 6px
        & + .stock-item
            margin-top: 0.5rem
        & > .info
            display: flex
            flex-direction: column
            & > .row.properties
                flex-grow: 1

    .modal-item + .modal-item
        margin-top: 1rem
        border-top: 1px solid #dcdfe6
        padding-top: 1rem

.shop-tabs .stock-item
    background: #fbfbfb
.packing-dialog
    &.pack
        &::v-deep
            .el-dialog__header
                background-color: $color-body
            .el-dialog__body
                padding: 0
        .modal-body
            padding: 20px
            background-color: $color-body
            &::v-deep
                .el-select
                    .el-input
                        width: 130px
                        .el-input__inner
                            border: 0
                .el-input-group__append
                    padding: 0 20px
                    .el-button
                        border: 0


        .modal-items
            padding: 20px
            min-height: 60px
            .modal-item.disabled
                opacity: 0.5
            .actions
                justify-content: center
                align-items: flex-end
                min-width: 0
                width: 50px
            .alert
                margin: 0

.item-option
    line-height: 1.3
    .row
        display: flex
        gap: 0.5rem
        & + .row
            margin-top: 0.25rem
    .name
        flex-grow: 1
        min-width: 0
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis
    .sku
        flex-grow: 1

    label + span.value:before
        content: ' '

    label
        font-style: italic
        font-weight: bold
        &.small
            font-size: 0.8em

    &::v-deep label
        font-weight: bold

.el-autocomplete-suggestion li .item-option
    padding-top: 8px
    padding-bottom: 8px

.actions .placeholder
    display: flex
    justify-content: center
    align-items: center
    flex-grow: 1
    // color: $--color-success
    // background: rgba($--color-success, 0.2)
    // border: 1px solid rgba($--color-success, 0.4)
    color: $--color-text-regular
    font-weight: bold
    border-radius: 4px
    pointer-events: none
    i + span
        margin-left: 5px
        font-size: 0.85rem

.packing-dialog
    dl
        margin-bottom: 2rem
        dt
            font-size: 1em
            // font-style: italic
            color: inherit
            margin-bottom: .5rem
    .el-form-item::v-deep > label
        font-style: initial
    > nomargin
        margin-left: 0
        margin-right: 0

.bold
    font-weight: bold
.mt
    margin-top: 20px
.mb0
    margin-bottom: 0px
.mb20
    margin-bottom: 20px
.mt0
    margin-top: 0px
.blue
    background: lightblue
    padding: 5px
.red
    color: red
.rated-shipments
    border-spacing: 0 12px
    width: 100%
    margin-top: 1rem
    font-weight: bold
    tr:nth-child(even)
        background: #f3f3f3
    td, th
        padding: 4px 12px
    td
        border: none
    .label
        padding-right: 12px
    .actions
        width: 1px
        white-space: nowrap
        padding: 4px
    .text-left
        text-align: left
    .text-right
        text-align: right
    .text-center
        text-align: center
    .button
        width: 100%

.upsform
    padding-right: 10px
    padding-left: 10px
    .flex
        justify-content: space-between
.modal-body
    .nomargin
        margin-left: 0
        margin-right: 0
.flex
    display: flex

.upsSuccess
    color: green

.strong
    font-weight: bold
    margin-bottom: 20px
</style>

